<div class="container">
  <form novalidate>
    <h1>{{ "login.title" | translate }}</h1>

    <button class="login-btn" type="button" appButton="light" (click)="ssoLogin()">
      {{ "login.ssoLogin" | translate }}
    </button>
  </form>
</div>
